// Atajos compartidos de los buscadores con filtros («/» y Esc), para el
// Avivador y la home (Ajuste #16). Puros: se testean en atajos.test.ts.
import type { AccionEscBuscador, TeclaBasica } from './tipos';

/** Valor de `aria-keyshortcuts` del buscador. */
export const ATAJO_BUSCAR = '/';

/**
 * ¿La tecla lleva el foco al buscador? `key === '/'`, sin Alt, Ctrl ni Meta,
 * sin composición de IME y con `escribiendo === false` (el foco NO está en un
 * input, textarea, select o contenteditable). Shift permitido: en el teclado
 * español «/» es Shift+7. El que llama hace `preventDefault()` y el focus.
 */
export function esAtajoBuscar(e: TeclaBasica, escribiendo: boolean): boolean {
  if (e.key !== ATAJO_BUSCAR) return false;
  if (e.altKey || e.ctrlKey || e.metaKey) return false;
  if (e.isComposing) return false;
  return !escribiendo;
}

/**
 * Esc dentro del buscador: con texto (cualquier caracter, aun espacios) →
 * 'limpiar'; vacío → 'blur' si `blurSiVacio` (Avivador: suelta el foco para
 * volver a las flechas), si no null (home: no hay grilla adonde volver).
 * El que llama hace `stopPropagation()` siempre y `preventDefault()` con 'limpiar'.
 */
export function accionEscBuscador(valor: string, opciones?: { blurSiVacio?: boolean }): AccionEscBuscador {
  if (valor.length > 0) return 'limpiar';
  return opciones?.blurSiVacio ? 'blur' : null;
}
